export enum ModuleSortType {
    Id,
    Name,
    IsDeleted
}
